import { toNumber } from 'lodash';
import { IPreviewTableFilters } from '../../../../types.ts';

interface IUsePreviewTableProps {
  filters: IPreviewTableFilters;
  setFilters: (newFilters: IPreviewTableFilters) => void;
}

export const usePreviewTable = ({
  filters,
  setFilters,
}: IUsePreviewTableProps) => {
  const { sort_order } = filters;

  const handleChangeOrder = (colName: IPreviewTableFilters['sort_by']) => {
    setFilters({
      ...filters,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      sort_by: colName as any,
      sort_order:
        filters.sort_by != colName
          ? sort_order
          : sort_order === 'ASC'
            ? 'DESC'
            : 'ASC',
    });
  };

  const onPageIndexChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number,
  ) => {
    setFilters({ ...filters, page: page + 1 });
  };

  const onPageSizeChange = (event: {
    target: {
      value: string;
    };
  }) => {
    setFilters({ ...filters, limit: toNumber(event.target.value), page: 1 });
  };

  return {
    handleChangeOrder,
    onPageIndexChange,
    onPageSizeChange,
  };
};
